<template>

    <SubHeader title="Fiche division" :breads="[{ name: 'Créer division' }, { name: 'Fiche division' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form  @submit.prevent="handleSubmit(data)">
                <!-- @csrf -->

                <div class="row">
                    <div class="col-md-6">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" id="label" class="form-control"
                                        placeholder="Division" v-model="data.label" required>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Enregistrer</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import {mapFields} from "vuex-map-fields"
import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";

export default {
    name: "AdminConfigCreateDivision",
    components: {
        SubHeader
    },
    data(){
        return {
            data:{}
        }
    },
    computed: {
        ...mapFields("division/create", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items",
            isCreated:"isCreated"

        }),
    },
    methods:{
        ...mapActions({
            handleSubmit:"division/create/create",
            reset:"division/create/resetData"
        })
    },
    watch:{
        isCreated(val){
            if(val){
                this.$router.push({name:"AdminConfigDivision"})
            }
        }
    },
    unmounted(){
        this.reset()
    }
}
</script>
